<script setup>
import { computed } from 'vue'

const props = defineProps({
  fluid: {
    type: Boolean,
    default: false
  }
})

const containerClasses = computed(() => {
  return props.fluid ? 'w-full px-4 sm:px-6 lg:px-8' : 'container mx-auto px-4 sm:px-6 lg:px-8'
})
</script>

<template>
  <div :class="containerClasses">
    <slot />
  </div>
</template>
